<template>
  <div class="layout-wrap">
    <div class="nav-wrap">
      <div class="nav-logo" @click="handleLogoClick">
        <img :src="require('../assets/images/logo.png').default" alt="">
      </div>
      <div class="nav-menu">
        <ul>
          <li @click="handleHome" :class="{'active': isActive === 'homeActive'}">
            <p>首页</p>
          </li>

          <!-- 注册：仅未登录时显示 -->
          <li
            v-if="!isLogin"
            @mouseout="handleRegOut"
            @mouseover="handleRegOver"
          >
            <p>注册 <i class="el-icon-arrow-down"></i></p>
            <div class="meun-list" v-show="reg">
              <div class="meun-item">
                <span @click="handlePlaReg">咨询师注册</span>
              </div>
              <div class="meun-item">
                <span @click="handleOrgReg">机构端注册</span>
              </div>
            </div>
          </li>

          <!-- 测试者登录：仅未登录时显示 -->
          <li
            v-if="!isLogin"
            @mouseout="handleOrganizationOut"
            @mouseover="handleOrganizationOver"
          >
            <p>测试者登录 <i class="el-icon-arrow-down"></i></p>
            <organization
              class="organization"
              @handleChangeCity="handleChangeCity"
              v-show="isShowOrganization"
              :orgList="orgList"
              @jump="jump"
            />
          </li>

          <!-- 登录后：咨询师页面（hover 显示完整下拉菜单） -->
          <li
            v-if="isLogin"
            class="planner-dropdown"
            @mouseenter="showPlannerMenu"
            @mouseleave="hidePlannerMenu"
            :class="{'active': isActive === 'plannerActive'}"
          >
            <p>咨询师 <i class="el-icon-arrow-down"></i></p>
            <transition name="fade">
              <div class="meun-list" v-show="plannerMenuVisible">
                <div class="meun-item" @click.stop="navigateTo('PlannerQAList')">
                  <span>问我问题</span>
                </div>
                <div class="meun-item" @click.stop="navigateTo('PlannerIssueList')">
                  <span>公共问题</span>
                </div>
                <div class="meun-item" @click.stop="navigateTo('PersonInfo')">
                  <span>个人信息</span>
                </div>
                <div class="meun-item" @click.stop="handleLogout()">
                  <span>退出登录</span>
                </div>
              </div>
            </transition>
          </li>

          <!-- 登录下拉：仅未登录时显示 -->
          <li
            v-if="!isLogin"
            @mouseout="handleAdministratorOut"
            @mouseover="handleAdministratorOver"
          >
            <p>登录 <i class="el-icon-arrow-down"></i></p>
            <div class="meun-list" v-show="Administrator">
              <div class="meun-item">
                <span @click="handleHoutai('zongpingtai')">管理端登录</span>
              </div>
              <div class="meun-item">
                <span @click="handleHoutai('jigou')">机构端登录</span>
              </div>
              <div class="meun-item">
                <span @click="handleLogin">咨询师登录</span>
              </div>
            </div>
          </li>

          <li @mouseout="handleCityOut" @mouseover="handleCityOver" class="city-wrap">
            <p>{{ currentCity }}</p>
          </li>
        </ul>
      </div>
    </div>

    <myselect :selectShow="selectShow" @handleClose="handleClose"></myselect>

    <div class="main-container">
      <router-view />
    </div>

    <div class="footer-wrap">
      <div class="w">
        <div class="footer-top">
          <div class="footer-item">
            <img :src="require('../assets/images/icon.png').default" alt="">
            <div>
              <p>电话：</p>
              <p>010-81761826</p>
            </div>
          </div>
          <div class="footer-item">
            <img class="www" :src="require('../assets/images/www.png').default" alt="">
            <div>
              <p>网址：</p>
              <p style="cursor: pointer;" @click="jumpHome">www.xinlicloud.com</p>
            </div>
          </div>
          <div class="footer-item">
            <img class="dizhi" :src="require('../assets/images/dizhi.png').default" alt="">
            <div>
              <p>地址：</p>
              <p>北京市昌平区宏福科技园宏福大厦</p>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <span @click="jumpBeian">京ICP备20012024号</span> 北京学能通科技集团有限公司版权所有
        </div>
      </div>
    </div>
    <div class="right-nav">
      <ul>
        <li>
          <div class="r-n-item">
            <i class="font-icon iconfont icon-qrCode qrCode"></i>
          </div>
          <div class="tel-wrap">
            <div class="code-wrap">
              <div class="code">
                <img :src="require('../assets/images/code.png').default" alt="">
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="r-n-item">
            <i class="font-icon el-icon-phone-outline"></i>
          </div>
          <div class="tel-wrap">
            <p>电话：<br/>010-81761826</p>
          </div>
        </li>
        <li @click="backtop" v-show="isShowTopBtn">
          <div class="r-n-item">
            <i class="font-icon el-icon-upload2"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import myselect from '@/components/OrgSelect'
import OrganizationSelect from './OrganizationSelect.vue'
import { mapState, mapMutations } from 'vuex'
import { RemoveAuthority } from '../authority' // 请确认路径正确

export default {
  data () {
    return {
      isShowTopBtn: false,
      blockName: '',
      consultantList: [],
      selectShow: false,
      Administrator: false,
      isShowCity: false,
      isShowOrganization: false,
      orgList: [],
      reg: false,
      plannerMenuVisible: false
    }
  },
  computed: {
    ...mapState(['isLogin', 'isActive', 'currentCity'])
  },
  created () {
    this.params = { level: '1' }
    this.getBlockNames(this.params)
    this.getCity()
  },
  mounted () {
    window.addEventListener('scroll', this.showbtn, true)
  },
  beforeUnmount () {
    window.removeEventListener('scroll', this.showbtn, true)
  },
  methods: {
    ...mapMutations(['handleCurrentCity', 'handleIsLogin']),

    // ===== 咨询师菜单控制 =====
    showPlannerMenu () {
      this.plannerMenuVisible = true
    },
    hidePlannerMenu () {
      this.plannerMenuVisible = false
    },
    // 导航到指定咨询师子页面
    navigateTo (routeName) {
      this.plannerMenuVisible = false
      this.$store.state.isActive = 'plannerActive'
      this.$router.push({ name: routeName }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },

    // ===== 登出逻辑 =====
    handleLogout () {
      this.plannerMenuVisible = false
      this.$router.push('/')
      this.$store.state.isActive = 'homeActive'
      this.handleIsLogin(false)
      localStorage.removeItem('isLogin')
      localStorage.removeItem('access_token')
      RemoveAuthority()
      this.$message.success('已安全退出')
    },

    // ===== 其他原有方法 =====
    jumpBeian () {
      window.open('https://beian.miit.gov.cn/')
    },
    jumpHome () {
      const BASE_API_WWW = process.env.VUE_APP_BASE_API_WWW
      window.open(BASE_API_WWW)
    },
    handleChangeCity (city) {
      if (!city) return
      this.isShowCity = false
      this.getOrgInfoByCity(city)
    },
    getOrgInfoByCity (city) {
      const cityData = { city }
      http.getOrgInfoByCity(cityData).then(res => {
        this.orgList = res.data.data
      })
    },
    handleCityOut () { this.isShowCity = false },
    handleCityOver () { this.isShowCity = true },
    handleRegOut () { this.reg = false },
    handleRegOver () { this.reg = true },
    handleOrganizationOut () { this.isShowOrganization = false },
    handleOrganizationOver () { this.isShowOrganization = true },
    handleAdministratorOut () { this.Administrator = false },
    handleAdministratorOver () { this.Administrator = true },
    handleClose () {
      this.selectShow = false
      document.body.style.overflow = ''
    },
    jump () {
      this.isShowOrganization = false
    },
    handleLogin () {
      this.$router.push({ path: '/login' })
    },
    handleHome () {
      this.$store.state.isActive = 'homeActive'
      this.$router.push({ path: '/' })
    },
    handleOrgReg () {
      this.$router.push({ path: '/registerOrg' })
    },
    handlePlaReg () {
      this.$router.push({ path: '/registerPlanner' })
    },
    handleLogoClick () {
      this.$router.push({ name: 'IndexPage' })
    },
    handleHoutai (type) {
      const BASE_API_SYS = process.env.VUE_APP_BASE_API_SYS
      const BASE_API_ORG = process.env.VUE_APP_BASE_API_ORG
      if (type === 'zongpingtai') {
        window.open(BASE_API_SYS)
      } else if (type === 'jigou') {
        window.open(BASE_API_ORG)
      }
    },
    getBlockNames (parems) {
      http.getBlockNames(parems).then(res => {
        let contents = ''
        if (res.data.data && Array.isArray(res.data.data)) {
          contents = res.data.data[0]
        }
        return contents
      }).then(res => {
        this.blockName = res.blockName
        this.acquireFirstPortalConsultTitleList(res.id)
      })
    },
    acquireFirstPortalConsultTitleList (id) {
      http.acquireFirstPortalConsultTitleList({ blockType: id }).then(res => {
        this.consultantList = res.data.data
      })
    },
    getCity () {
      const self = this
      AMap.plugin('AMap.Geolocation', function () {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000
        })
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete)
        AMap.event.addListener(geolocation, 'error', onError)

        function onComplete (data) {
          self.getLngLatLocation()
        }
        function onError (data) {
          console.log('定位失败错误：', data)
        }
      })
    },
    getLngLatLocation () {
      AMap.plugin('AMap.CitySearch', () => {
        const citySearch = new AMap.CitySearch()
        citySearch.getLocalCity((status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            const city = result.city
            this.handleCurrentCity(city)
            this.getOrgInfoByCity(city)
          }
        })
      })
    },
    showbtn () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isShowTopBtn = scrollTop > 500
    },
    backtop () {
      const timer = setInterval(() => {
        const osTop = document.documentElement.scrollTop || document.body.scrollTop
        const ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    }
  },
  components: {
    myselect,
    organization: OrganizationSelect
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.scss';

.layout-wrap {
  width: 100%;

  .nav-wrap {
    width: 1200px;
    height: 85px;
    margin: 0 auto;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-logo {
      width: 210px;
      height: 80px;
      cursor: pointer;
      img {
        width: 150px;
        height: 40px;
        margin-top: 17px;
      }
    }

    .nav-menu {
      ul {
        display: flex;
        justify-content: center;
        li {
          padding: 0 16px;
          color: $el-main-color;
          cursor: pointer;
          position: relative;
          p {
            line-height: 85px;
            margin: 0;
          }
          &.active {
            color: #FF8B00;
          }
          &:hover:not(.planner-dropdown) {
            color: #FF8B00;
          }
        }

        // 咨询师下拉专用样式
        .planner-dropdown {
          p {
            display: flex;
            align-items: center;
            gap: 4px;
            i {
              font-size: 12px;
              transition: transform 0.2s;
            }
          }
          &:hover {
            color: #FF8B00;
          }
        }

        .meun-list {
          min-width: 166px;
          border-radius: 5px;
          background: #fff;
          position: absolute;
          top: 82px;
          left: 50%;
          margin-left: -83px;
          z-index: 1000;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          overflow: hidden;

          .meun-item {
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            transition: background 0.2s;
            &:hover:not(.logout-item) {
              background-color: #f9f9f9;
            }
            span {
              display: block;
              width: 100%;
              text-align: center;
              padding: 0 12px;
            }
          }

          .logout-item {
            border-top: 1px solid #eee;
            margin-top: 4px;
            padding-top: 4px;
            .handleLogout {
              color: #e74c3c;
              &:hover {
                background-color: #fdf2f2 !important;
                color: #c0392b;
              }
            }
          }
        }
      }

      .city-wrap:hover {
        position: static;
      }

      .organization {
        width: 1200px;
        height: 850px;
        background: #fff;
        position: absolute;
        top: 85px;
        left: 50%;
        margin-left: -655px;
        box-shadow: 0 10px 10px rgba(0,0,0,.3);
        z-index: 100;
      }
    }
  }

  // 下拉菜单淡入淡出动画
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s ease;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  .main-container {
    min-height: calc(100vh - 85px - 120px);
    padding: 20px 0;
    box-sizing: border-box;
  }

  .footer-wrap {
    height: 120px;
    background: url(../assets/images/footer.png) no-repeat center;
    background-size: cover;
    color: #fff;
    overflow: hidden;
    .w {
      width: $el-center;
      margin: 0 auto;
      overflow: hidden;
    }
    .footer-top {
      margin: 25px 0 0 0;
      display: flex;
      justify-content: space-between;
      align-items: flex-start; /* 让子项顶部对齐 */

      .footer-item {
        display: flex;
        font-size: 14px;
        align-items: flex-start; /* 图标和文字垂直对齐 */
        gap: 8px; /* 增加图标与文字间距，避免太挤 */

        img {
          width: 20px; /* 缩小图标尺寸 */
          height: 24px;
          margin-top: 4px;
          vertical-align: middle;
          flex-shrink: 0;
        }

        div {
          display: flex;
          flex-direction: column;
          line-height: 1.4; /* 控制行高 */
          p {
            margin: 0;
            color: #fff;
          }
        }
      }
    }
    .footer-bottom {
      text-align: center;
      font-size: 14px;
      margin-top: 30px;
      span {
        cursor: pointer;
      }
    }
  }

  .right-nav {
    position: fixed;
    right: 80px;
    bottom: 100px;
    ul {
      li {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        position: relative;
        background: #fff;
        box-shadow: 0 0 20px rgba(0,0,0,.3);
        margin-bottom: 20px;

        .r-n-item {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 30px;
          color: #666666;
          cursor: pointer;
        }

        .qrCode {
          font-size: 32px !important;
        }

        .tel-wrap {
          padding: 20px;
          background: #fff;
          box-shadow: 0 0 20px rgba(0,0,0,.3);
          border-radius: 5px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          display: none;
          opacity: 0;
          right: 110%;
          transition: opacity 0.3s, right 0.3s;
          white-space: nowrap;
          .code-wrap {
            text-align: center;
            .code {
              img {
                width: 150px;
                height: 150px;
              }
            }
          }
        }

        &:hover {
          .tel-wrap {
            display: block;
            opacity: 1;
            right: 110%;
          }
          .font-icon {
            color: $el-main-color;
          }
        }
      }
    }
  }
}
</style>
